import { Button } from "@mui/material";
import BottomBar from "../Components/BottomBar.jsx";
import FloatingWhats from "../Components/FloatingWhats.jsx";
import Footer from "../Components/Footer.jsx";
import Header from "../Components/Header.jsx";
import styles from "../styles/BalancasCuiaba.css"
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Box, IconButton } from '@mui/material';
import { Grid, styled } from '@mui/system';
import React, { useState } from 'react';

const images = [
    '../images/foto1.png',
    '../images/foto1.png',
    '../images/foto1.png',
    '../images/foto1.png',
    '../images/foto1.png'
  ];

const ImageBox = styled(Box)(({ theme }) => ({
    position: 'relative',
    width: 275,
    borderRadius: 10,
    height: 355,
    overflow: 'hidden',
    '&:hover': {
      cursor: 'pointer',
      '& img': {
        opacity: 0.6
      },
      '& .zoomIcon': {
        color:'#474747',
        display: 'block',
      },
    },
  }));

const ZoomIcon = styled(ZoomInIcon)(({ theme }) => ({
    color: '#fff',
    fontSize: '3rem',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'none',
  }));
  
  const StyledModal = styled(Modal)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));
  
  const CloseButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: 10,
    right: 10,
    color: '#fff',
  }));

const BalancasCuiaba = () => {
    const [open, setOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);

    const handleOpen = (image) => {
        setCurrentImage(image);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentImage(null);
    };

    return(
        <div className="container">
            <FloatingWhats/>
            <Header/>    
            <div className="content">
                <div className="bannerInterno-container from-top">
                    <div className="bannerInterno-content">
                        <div className="bannerInterno">
                            <h1 className="bannerInterno-title">Balanças<br/>Cuiabá</h1>
                            <img className="bannerInterno-img comercial-logo" src="../images/logobc.svg" alt="Banner Assitência-Técnica"/>
                        </div>
                    </div>
                </div>
                <div className="abrangencia">
                    <div className="abrangencia-content">
                        <div className="abrangencia-left from-left" style={{maxWidth:'650px'}}>
                            <h3 className="abrangencia-subtitle from-left">Balanças Cuiabá</h3>
                            <h2 className="abrangencia-title from-left">Quem Somos?</h2>
                            <div className="abrangencia-textBox">
                                <div className="abrangencia-bar"/>
                                <div className="abrangencia-text">
                                    <p className="abrangencia-textContent from-left">Atuando há mais de 25 anos oferecendo as melhores soluções em pesagem disponíveis no mercado.</p>
                                    <p className="abrangencia-textContent from-left">A Empresa Balanças Cuiabá, atua a mais de 25 anos no segmento de soluções pesagens da agroindustria em todo território nacional e países do Mercosul, conta hoje com uma moderna fábrica na cidade de Cascavel no Oeste do PR e investe constantemente em pesquisas para oferecer sempre as melhores opções de pesagem, automação e ensacamento de grãos, fornecendo hardware e software e serviços de assistência técnica, contribuindo com o desenvolvimento do Agro em todo pais, nosso principal objetivo é garantir a eficiência nas pesagens e ensacamentos com agilidades nos processos e redução de custos.</p>
                                </div>
                            </div>
                            <span className="balancasCuiaba-bottomText from-left">Agilidade e disponibilidade<br/>para o melhor atendimento!</span>
                        </div>
                        <div className="balancasCuiaba-right from-right">
                            <div className="galeria-container">
                                <ImageBox sx={{ width: '100%', height: 390, marginBottom: 2 }} onClick={() => handleOpen(images[0])}>
                                    <img className="from-right" src={images[0]} alt="Imagem principal" style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
                                    <ZoomIcon className="zoomIcon" />
                                </ImageBox>
                                <div className="galeria-grid from-right">
                                    {images.slice(1).map((image, index) => (
                                        <ImageBox
                                            key={index}
                                            sx={{
                                                width: '100%',
                                                height: 130
                                            }}
                                            onClick={() => handleOpen(image)}
                                        >
                                            <img
                                                src={image}
                                                alt={`Imagem ${index + 2}`}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                            <ZoomIcon className="zoomIcon" />
                                        </ImageBox>
                                    ))}
                                </div>

                            </div>
                            
                            <StyledModal open={open} onClose={handleClose}>
                                <Box sx={{ position: 'relative', maxWidth: '90%', maxHeight: '90%', outline:"none", border:'none' }}>
                                    <CloseButton onClick={handleClose}>
                                        <CloseIcon />
                                    </CloseButton>
                                    {currentImage && <img src={currentImage} alt="Imagem ampliada" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />}
                                </Box>
                            </StyledModal>
                        </div>
                    </div>
                </div>
                <div className="usDados">
                    <div className="usDadosContent">
                        <div className="us1 from-bottom">
                            <div className="usDadosTitle">25 anos</div>
                            <div className="usDadosText">oferecendo as melhores soluções</div>
                        </div>
                        <div className="us2 from-bottom" style={{ transitionDelay: '0.1s' }}>
                            <div className="usDadosTitle">500+</div>
                            <div className="usDadosText">clientes satisfeitos</div>
                        </div>
                        <div className="us3 from-bottom" style={{ transitionDelay: '0.2s' }}>
                            <div className="usDadosTitle">1000+</div>
                            <div className="usDadosText">equipamentos entregues</div>
                        </div>
                        <div className="us4 from-bottom" style={{ transitionDelay: '0.3s' }}>
                            <div className="usDadosBar"/>
                            <div className="usDadosText">CONHEÇA NOSSOS<br/>PRODUTOS</div>
                        </div>
                    </div>
                </div>                        
                <div className="mvv">
                    <div className="mvv-content">
                        <div className="mvv-block from-bottom" style={{transitionDelay:'0.1s'}}>
                            <img src="images/icons/missao.svg" className="mvv-icon"/>
                            <h2 className="mvv-title">MISSÃO</h2>
                            <h4 className="mvv-text">Proporcionar aos nossos clientes e parceiros, excelência em atendimento, e as melhores soluções em equipamentos de pesagem com eficiência e assistência técnica qualificada em todo o Brasil.</h4>
                        </div>
                        <div className="mvv-block from-bottom" style={{transitionDelay:'0.2s'}}>
                            <img src="images/icons/visao.svg" className="mvv-icon"/>
                            <h2 className="mvv-title">VISÃO</h2>
                            <h4 className="mvv-text">Reconhecimento pelo trabalho feito com responsabilidade e honestidade, Sendo transparente para gerar confiança, fidelidade e oferecer os melhores Equipamentos para pesagens.</h4>
                        </div>
                        <div className="mvv-block from-bottom" style={{transitionDelay:'0.3s'}}>
                            <img src="images/icons/valores.svg" className="mvv-icon"/>
                            <h2 className="mvv-title">VALORES</h2>
                            <h4 className="mvv-text">Responsabilidade ecológica, consideração por nossos colaboradores e comprometimento com nossos clientes.</h4>
                        </div>
                    </div>
                </div>
                <div className="estContainer">
                    <div className="estContent">
                        <div className="estHeader">
                            <div className="estHL from-left">
                                <div className="est-subTitle">Estrutura</div>
                                <div className="est-title">Conheça nossa<br/>estrutura</div>
                            </div>
                            <div className="estHR from-right">
                                Temos os melhores produtos e equipamentos do mercado<br/>para oferecer o melhor atendimento aos nossos clientes.
                            </div>
                        </div>
                        <div className="estBody">
                            <div className="estRight from-bottom">
                                
                                <div className="estTextR">
                                <h2 className="estTitle">Recepção</h2>
                                Nossa recepção foi pensada para oferecer um atendimento ágil e acolhedor, onde cada detalhe transmite organização, respeito e profissionalismo. Desde o primeiro contato, buscamos entender sua necessidade com atenção e clareza. Aqui, você encontra um ambiente preparado para receber clientes e parceiros com transparência, seja para um café rápido, uma conversa produtiva ou o início de um grande projeto. Porque, para nós, um bom atendimento começa no primeiro contato e reflete em toda a experiência com a Balanças Cuiabá.
                                </div>
                                <img src="images/recepcao.png" className="estFoto"/>
                            </div>
                            <div className="estLeft from-bottom">
                                <img src="images/recepcao.png" className="estFoto"/>
                                <div className="estTextL">
                                <h2 className="estTitle">Fábrica</h2>
                                Nossa fábrica é o coração da Balanças Cuiabá, onde tecnologia e experiência se unem para entregar soluções robustas e confiáveis. Cada etapa do processo é realizada com rigor técnico e atenção aos detalhes, garantindo qualidade, durabilidade e precisão. Trabalhamos com equipamentos modernos e uma equipe especializada, comprometida em desenvolver produtos que atendam às exigências do mercado e dos órgãos reguladores. Aqui, cada projeto ganha forma com responsabilidade e excelência.
                                </div>
                            </div>
                            <div className="estRight from-bottom">
                                <div className="estTextR">
                                <h2 className="estTitle">Laboratório</h2>
                                Nosso laboratório é o espaço onde a precisão é levada a sério. Equipado com instrumentos adequados e seguindo padrões técnicos rigorosos, realizamos testes, calibrações e verificações que garantem o desempenho ideal dos equipamentos. Cada procedimento é executado por profissionais capacitados, assegurando confiabilidade nos resultados e conformidade com as normas vigentes. É aqui que reforçamos nosso compromisso com a qualidade e a exatidão em cada entrega.
                                </div>
                                <img src="images/recepcao.png" className="estFoto"/>
                            </div>
                            <div className="estLeft from-bottom">
                                <img src="images/recepcao.png" className="estFoto"/>
                                <div className="estTextL">
                                <h2 className="estTitle">Time Comercial</h2>
                                Nossa sala comercial foi pensada para proporcionar um atendimento próximo, consultivo e eficiente. Aqui, nossa equipe está preparada para entender cada necessidade e oferecer as melhores soluções em pesagem, com clareza e transparência. Valorizamos o relacionamento com nossos clientes, buscando sempre construir parcerias sólidas e duradouras. Mais do que vender, nosso objetivo é orientar e entregar confiança em cada negociação.
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div className="work-container">
                    <div className="work-content from-bottom">
                        <h3 className='work-title'>Trabalhe Conosco</h3>
                        <div className="work-line"/>
                        <div className="work-subtitle">Venha fazer parte da nossa equipe!</div>
                        <div className="work-links">
                            <a href='https://linkedin.com'><img src="https://odontoluzzi.com.br/images/linkedin.svg" className="linkedIn"/></a>
                            <a href='https://infojobs.com'><img src="https://odontoluzzi.com.br/images/ij.svg" className="infoJobs" style={{width:'33px'}}/></a>
                        </div>
                    </div>
                </div>
                <div className="mapContainer">
                    <div className="mapContent from-bottom">
                        <iframe className='map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3617.1248155114586!2d-53.399700599999996!3d-24.961867699999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94f3d51f26f2fa53%3A0xbeb810eac02ae099!2zQmFsYW7Dp2FzIEN1aWFiw6EgLSBCYWxhbsOnYXMgUm9kb3Zpw6FyaWFz!5e0!3m2!1spt-BR!2sbr!4v1779065786700!5m2!1spt-BR!2sbr" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> 
                    </div>
                </div>









                <BottomBar/>
                <Footer/>
            </div>
        </div>
    )
}
export default BalancasCuiaba;